module.exports = __webpack_public_path__ + "static/media/link-icon.7279ea23.svg";